import type { room as en } from '../en/room';

export const room: typeof en = {
  connectingTitle: '正在准备房间…',
  connectingDescription: '正在连接 Zumpo，通常只需片刻。',
  connecting: '连接中…',
  unavailableTitle: '这个房间暂时进不去了。',
  unavailableDescription:
    '玩家席和观战席都满了，或房间在你加入前已关闭。选另一个房间吧。',
  notFoundTitle: '这个房间已关闭。',
  notFoundDescription: '房间已不存在。找另一个房间，或自己创建一个。',
  closedTitle: 'Zumpo 刚刚重启了。',
  closedDescription:
    'Zumpo 更新重启时会关闭所有房间，这一局也结束了。找另一个房间，或自己创建一个。',
  expiredTitle: '重新开始吧。',
  expiredDescription: '无法重新连接，你的座位可能已被释放。可以返回房间列表。',
  backToRooms: '返回房间列表',
  passwordDescription: (name) =>
    name ? `请输入“${name}”的密码。` : '请输入这个房间的密码。',
  comeIn: '进来吧',
  passwordTitle: '这个房间需要密码。',
  join: '加入房间',
  password: '房间密码',
  passwordHelper: '向房主询问房间密码。',
  passwordPhoneHelper: '向房主询问密码。',
  passwordRejected: '密码不对，再试一次。',
  joining: '正在加入房间…',
  reconnecting: '重新连接中…',
  reconnectingNotice: (name, seconds) =>
    `正在重新连接“${name}”…你的座位和得分会保留 ${seconds} 秒。`,
  board: '游戏',
  nowHost: '你现在是房主了。',
  playerAway: (name) => `${name} 暂离了。`,
  playerLeft: (name) => `${name} 离开了房间。`,
  leftNowHost: (name) => `${name} 离开了房间，你现在是房主了。`,
  players: (count) => `玩家 · ${count}`,
  chat: '聊天',
  turnTitle: '(!) 轮到你了',
  leaveTitle: (name) => `离开“${name}”？`,
  leaveInGame: (score) =>
    `游戏会继续，但你的座位和${score}会被移除。还有空位时，你可以再次加入。`,
  leaveInGameNoScore:
    '游戏会继续，但你的座位会被移除。还有空位时，你可以再次加入。',
  leaveEndsGame: '剩下的玩家会不够，所以你离开后，这一局对所有人都会结束。',
  leaveResigns: (opponent) => `离开会结束这一局，${opponent} 获胜。`,
  leaveNextHost: (name) => `${name} 会成为房主。`,
  leaveCloses: '房间里没有别人了，所以房间会关闭。',
  both: (first, second) => `${first}${second}`,
  leaveBetweenGames: '你的座位会被释放。还有空位时，你可以再次加入。',
  leaveSpectating:
    '你只是在观战，离开不会有任何损失。观战席有空位时可以再回来。',
  leave: '离开房间',
  stay: '留下',
  watching: '观战席',
  spectator: '观战中',
  watch: '去观战',
  sit: '加入玩家席',
  moving: '正在换座…',
  refused: {
    notEnoughPlayers: '还需要更多玩家才能开始。',
    notRoomOwner: '只有房主可以开始游戏。',
    notStarter: '只有房主可以更改下一局。',
    gameAlreadyStarted: '游戏已经开始了。',
    seatsTaken: '牌桌上的座位都满了。',
    spectatorSeatsTaken: '观战席已经满了。',
    noAnswer: 'Zumpo 没有回应，请再试一次。',
    failed: '没有成功，请再试一次。',
  },
  spectatingTitle: '你在观战席。',
  spectatingSeatFree: '加入玩家席就能参加下一局，也可以继续观战。',
  spectatingSeatsFull: '玩家席已满，有人空出座位后就能加入。',
  spectatingNotice: '观战中。本局结束后可加入玩家席。',
  watchingLead: '观战中',
  rulesTitle: (game) => `「${game}」玩法`,
  backToGame: '返回游戏',
  invite: '邀请好友',
  inviteDescription: (name) =>
    `还有空位时，任何拿到链接的人都可以加入“${name}”。`,
  copied: '已复制',
  linkCopied: '链接已复制',
  shareText: (game, roomName) => `来“${roomName}”和我一起玩${game}吧。`,
  copy: '复制',
  done: '完成',
  roomLink: '房间链接',
  pickedName: (name) => `你现在叫 ${name}。起一个好友们认得出的名字吧。`,
  waitingForHost: (name) => `等待 ${name} 开始游戏。`,
  guestSetup: (setup) => `${setup}只有房主可以开始游戏。`,
  needsPlayers: (game, fewest) =>
    `${game}至少需要 ${fewest} 人。分享房间，邀请好友加入就能开始。`,
  everyoneHere: '大家到齐了吗？',
  here: (names) => `${names} 已经在房间里了。`,
  starting: '正在开始游戏…',
  start: '开始游戏',
  everyoneLeft: '其他人都离开了。',
  endedEarly: (game) =>
    `${game}至少需要 2 人，因此这一局已结束。邀请好友开始新的一局吧。`,
  endedEarlyNewHost: (game) =>
    `${game}至少需要 2 人，因此这一局已结束。你现在是房主，邀请好友开始新的一局吧。`,
  waitingForAgain: (name) => `等待 ${name} 开始下一局。`,
  playAgain: '再玩一局',
  nextGame: '下一局',
  nextGameIs: (setting) => `下一局：${setting}`,
  ready: '准备',
  notReady: '取消准备',
  readyHint: (starter) =>
    `大家都准备好就开始下一局，${starter} 也可以直接开始。`,
  waitingOnReady: (names, starter) =>
    `你已准备。等待 ${names}，或由 ${starter} 开始。`,
  areReady: (names) => `${names} 已准备。`,
  standIn: (host) => `${host} 不在座位上，由你来开始下一局。`,
  short: {
    ready: '准备好下一局了吗？',
    waitingFor: (names) => `等待 ${names}`,
    areReady: (names) => `${names} 已准备`,
    standIn: (host) => `${host} 不在，由你开始`,
  },
  gameOver: '游戏结束。',
  wins: (name, score) => `${name} 以 ${score}获胜。`,
  ties: (names, score) => `${names} 以 ${score}并列获胜。`,
  youWin: (score) => `你以 ${score}获胜。`,
  youTie: (others, score) => `你和 ${others} 以 ${score}并列获胜。`,
  finished: (detail, place) => `${detail}你获得了${place}。`,
  standings: '排名',
  winner: '获胜者',
  place: (place) => place,
  listNames: (names) => {
    if (names.length <= 1) return names.join('');
    return `${names.slice(0, -1).join('、')} 和 ${names[names.length - 1]}`;
  },
  ordinal: (place) => `第 ${place} 名`,
};
